import React, { FC, useContext, useMemo } from 'react';
import { PageHeader } from '../components/PageHeader/PageHeader';
import { OrganizationProducts } from '../components/Customer/OrganizationProducts';
import {
  OrganizationAvailableProductsFetcher,
  OrganizationProductsFetcher,
  OrganizationScheduledProductsFetcher,
} from '../components/Customer/CustomerFetchers';
import { useTranslation } from 'react-i18next';
import { IQuickFilter, IQuickFiltersProps } from '../components/EasyFilter/QuickFilters';
import { EasyFilter } from '../components/EasyFilter/EasyFilter';
import { expiresSoon } from '../helpers/expiresSoon';
import { OrganizationScheduledProducts } from '../components/Customer/OrganizationScheduledProducts';
import { FilteringContextProvider } from '../contexts/FilteringContext';
import Button from '@mui/material/Button';
import { config } from '../config';
import Email from '@mui/icons-material/Email';

const ProductsFilter: FC<{ baseFilters: Map<string, IQuickFilter> }> = ({ baseFilters }) => {
  const { t } = useTranslation();

  const { data } = useContext(OrganizationProductsFetcher.Context);
  const rows = data?.customerProducts;

  const quickFilters = useMemo<IQuickFiltersProps['quickFilters']>(() => {
    const newMap = new Map(baseFilters);

    newMap.set(t('common.quickFilter.expireSoon'), {
      filterField: 'status',
      filterOp: 'equals',
      filterVal: 'expiresSoon',
      sortBy: 'expires',
      sortOrder: 'asc',
      isVisible: rows?.some((row) => expiresSoon(row.expiresAt)),
    });

    return newMap;
  }, [baseFilters, rows]);

  return <EasyFilter quickFilters={quickFilters} />;
};

export const CurrentOrganizationProductsPage: FC = () => {
  const { t } = useTranslation();

  const quickFilters = useMemo<IQuickFiltersProps['quickFilters']>(
    () =>
      new Map([
        [
          t('common.quickFilter.valid'),
          {
            filterField: 'valid',
            filterOp: 'equals',
            filterVal: 'true',
            isDefault: true,
          },
        ],
      ]),
    []
  );

  return (
    <div>
      <FilteringContextProvider quickFilters={quickFilters}>
        <PageHeader title={t('layout.navigation.products')}>
          <Button variant="contained" color="primary" href={`mailto:${config.salesEmail}`} endIcon={<Email />}>
            {t('products.contactSalesButton')}
          </Button>
        </PageHeader>
        <OrganizationScheduledProductsFetcher.WAF>
          <OrganizationProductsFetcher.WAF>
            <OrganizationAvailableProductsFetcher.WMF>
              <OrganizationScheduledProducts defaultExpanded={false} />
              <ProductsFilter baseFilters={quickFilters} />
              <OrganizationProducts hideDiscovery={true} />
            </OrganizationAvailableProductsFetcher.WMF>
          </OrganizationProductsFetcher.WAF>
        </OrganizationScheduledProductsFetcher.WAF>
      </FilteringContextProvider>
    </div>
  );
};
